/**
 * @generated SignedSource<<77d8a7df6a6e9995cd1f963f0541b8fd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CommentsModeEnum = "qa" | "standard" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MetadataContainer_feedContentResource$data = {
  readonly categories: ReadonlyArray<{
    readonly path: string;
    readonly slug: string;
    readonly title: string;
  }>;
  readonly comments: {
    readonly enabled: boolean;
    readonly mode: CommentsModeEnum;
  };
  readonly id: string;
  readonly internalCategories: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"AdminContainer_resolvedResource" | "ArticleSEOContainer_feedContentResource" | "ContentAdsContainer_contentResource" | "ContentResourceAnalyticsContainer_contentResource" | "CskCoralDrawer_contentResource" | "ParselyTagsContainer_feedContentResource" | "SEOSchemasContainer_feedContentResource" | "SearchTagsContainer_feedContentResource">;
  readonly " $fragmentType": "MetadataContainer_feedContentResource";
};
export type MetadataContainer_feedContentResource$key = {
  readonly " $data"?: MetadataContainer_feedContentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"MetadataContainer_feedContentResource">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MetadataContainer_feedContentResource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentsType",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryResourceType",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InternalCategoryResourceType",
      "kind": "LinkedField",
      "name": "internalCategories",
      "plural": true,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AdminContainer_resolvedResource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ArticleSEOContainer_feedContentResource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentResourceAnalyticsContainer_contentResource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParselyTagsContainer_feedContentResource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SearchTagsContainer_feedContentResource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SEOSchemasContainer_feedContentResource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentAdsContainer_contentResource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CskCoralDrawer_contentResource"
    }
  ],
  "type": "FeedContentResourceInterface",
  "abstractKey": "__isFeedContentResourceInterface"
};
})();

(node as any).hash = "48d8454791d217f32f51a112390ce62e";

export default node;
